import React, { useEffect, useState, useRef } from "react";
import { dataUserSession } from "../../../utilities/dataSession";
import { useHistory } from "react-router-dom";
import { Loading } from "../../../components/Loading/Loading";
import { Toast } from "primereact/toast";
import { Button } from "primereact/button";
import ValidateService from "../../../components/ValidateService/ValidateService";
import { DialogShow_2 } from "../../../components/DialogService/DialogService";
import { pCtCiaCameraList, pCtCiaCameraUpdate } from "../../../service/400/P421Service";
import { ciaCameraNameSync } from "../../../service/CIA/CiaService";
import P421List from "./P421List";
import P421Dialog from "./P421Dialog";
import P421DialogSync from "./P421DialogSync";

export default function P421() {
    const history = useHistory();
    const toast = useRef(null);
    const [dataList, setDataList] = useState([]);
    const [loading, setLoading] = useState(false);
    const showMessages = (severity = "error", summary = "", detail = "") => {
        toast.current.show({ severity: severity, summary: summary, detail: detail, life: 10000 });
    };
    const [submitted, setSubmitted] = useState(false);
    const [keyDown, setKeyDown] = useState({});
    const [showDialog, setShowDialog] = useState(false);
    const [textShow, setTextShow] = useState("");
    const [errData, setErrData] = useState(null);
    const [dialog, setDialog] = useState({
        open: false,
        action: "",
        dataSet: null,
    });

    const [dialogSync, setDialogSync] = useState({
        open: false,
    });

    const [searchData] = useState({

        userId: dataUserSession() ? dataUserSession().userId : "",
    });


    const [showDialogSync, setShowDialogSync] = useState(false);
    const [textShowSync, setTextShowSync] = useState("");

    useEffect(() => {
        if (!dataUserSession()) {
            history.push("/login");
        }
    }, []);

    useEffect(() => {
        onGetDataList();
    }, [searchData, dialog]);

    const onGetDataList = async () => {
        setLoading(true);
        let req = {
            userId: searchData.userId,
        };

        await pCtCiaCameraList(req).then(
            (res) => {
                setLoading(false);
                if (res !== undefined) {
                    let temp = [];
                    let index = 1;
                    res.forEach((element) => {
                        temp.push({
                            ...element,
                            index: index,
                        });
                        index++;
                    });
                    setDataList(temp);
                } else {
                    showMessages("error", `เกิดข้อผิดพลาด `, `ไม่พบข้อมูล`);
                }
            },
            function (err) {
                setLoading(false);
                setErrData(err);
            }
        );
    };
    const handlerOpenDialog = (_open, act, data) => {
        setDialog({ open: _open, action: act, dataSet: data, userId: dataUserSession().userId });
    };


    const handlerAction = (rowData) => {
        console.log("rowData : ", rowData);

        handlerOpenDialog(true, rowData.action, rowData);

    };

    const handlerOpenDialogSync = (_open, act, data) => {
        setDialogSync({ open: _open });
    };

    const handlerActionSync = () => {


        handlerOpenDialogSync(true);

    };


    const validation = (object) => {
        if (object.cameraId === "") {
            setSubmitted(true);
            return false;
        } else {
            setSubmitted(false);
            return true;
        }
    };

    const submitForm = async (data) => {
        console.log("data : ", data);
        if (validation(data)) {
            setLoading(true);
            let req = {
                actionCode: dialog.action,
                cameraId: data.cameraId,
                cameraName: data.cameraName,
                contractorCode: data.contractorCode,
                userId: dialog.userId,
            };
            await pCtCiaCameraUpdate(req).then((res) => {
                setLoading(false);


                if (res[0].statusCode === "C") {
                    setTextShow(res[0].statusText);
                    setDialog(false);
                    setShowDialog(true);
                    onGetDataList();
                } else if (res[0].statusCode === "E") {
                    setTextShow(res[0].statusText);
                    setShowDialog(true);
                }



            },
                function (err) {
                    setDialog(false);
                    setLoading(false);
                    setErrData(err);
                });
        }
    };

    const submitFormSync = async () => {
        setLoading(true);
        let req = {
            userId: searchData.userId,
        }
        await ciaCameraNameSync(req).then((res) => {
            setLoading(false);
            if (res.errorcode === 0) {
                setTextShowSync("ผลการทำงาน Sync ข้อมูลทั้งหมด" + res.totalCount + "รายการ เป็นบันทึกรายการใหม่" + res.totalCountUpDate + "รายการ");
                setShowDialogSync(true);
            } else if (res.errorcode === 1) {
                setTextShow(res[0].statusText);
                setShowDialog(true);
            }
        },
            function (err) {
                setDialog(false);
                setLoading(false);
                setErrData(err);
            })
    }



    return (
        <>
            <Loading loading={loading} />
            <ValidateService err={errData} setErr={setErrData} />
            <div className="p-grid crud-demo">
                <Toast ref={toast} position="top-right" />
                <div className="p-col-12">
                    <div className="card">
                        <div className="p-grid  p-fluid">
                            <div className="p-field p-col-12 p-md-6">
                                <Button
                                    className="p-button-secondary p-button btn-long-top-responsive"
                                    icon="pi pi-arrow-left"
                                    label="กลับหน้าจอหลัก"
                                    // style={{ display: 'flex',marginBottom : '10px' }}
                                    style={{ width: 170, marginLeft: "5px" }}
                                    onClick={() => {
                                        history.push("/400");
                                    }}
                                />
                            </div>

                        </div>
                        <P421List dataList={dataList} setAction={handlerAction} setActionSync={handlerActionSync} />
                    </div>
                </div>
            </div>
            {dialog.open === true ? (
                <>
                    <P421Dialog dialog={dialog} setDialog={setDialog}
                        onGetDataList={onGetDataList}
                        submitForm={submitForm}
                        setSubmitted={setSubmitted}
                        submitted={submitted}
                        setKeyDown={setKeyDown}
                        keyDown={keyDown} />
                </>
            ) : (
                ""
            )}
            <DialogShow_2 visible={showDialog} header="แจ้งเตือน" modal onHide={() => setShowDialog(false)} className="p-fluid" textContent={textShow} btnCancle={() => setShowDialog(false)} />

            {dialogSync.open === true ? (
                <>
                    <P421DialogSync dialog={dialogSync} setDialog={setDialogSync} showDialog={showDialogSync} textShow={textShowSync} submitFormSync={submitFormSync} setShowDialog={setShowDialogSync} onGetDataList={onGetDataList} />
                </>
            ) : ("")}
        </>
    );
};

